import { create } from 'zustand';

/** Accessibility font scale — bumps the root font size so the rem-based UI scales. */
export type FontScale = 'sm' | 'md' | 'lg';

const STORAGE_KEY = 'ted-font-scale';
const ROOT_PX: Record<FontScale, string> = { sm: '15px', md: '16px', lg: '18px' };

function applyFontScale(scale: FontScale): void {
  if (typeof document === 'undefined') return;
  document.documentElement.style.fontSize = ROOT_PX[scale];
}

function readStored(): FontScale {
  if (typeof window === 'undefined') return 'md';
  const value = window.localStorage.getItem(STORAGE_KEY);
  return value === 'sm' || value === 'md' || value === 'lg' ? value : 'md';
}

interface A11yState {
  fontScale: FontScale;
  setFontScale: (scale: FontScale) => void;
}

export const useA11yStore = create<A11yState>((set) => ({
  fontScale: readStored(),
  setFontScale: (scale) => {
    if (typeof window !== 'undefined') window.localStorage.setItem(STORAGE_KEY, scale);
    applyFontScale(scale);
    set({ fontScale: scale });
  },
}));

/** Apply the stored font scale at startup. Call once when the app mounts. */
export function initA11y(): void {
  applyFontScale(useA11yStore.getState().fontScale);
}
